<div class="relative top-0 left-0 h-full w-full">
  <div class="sm:py-8   flex justify-center my-auto h-full w-full" style="">

    <div class=" px-4 py-4 max-h-min bg-white shadow sm:rounded-lg w-full md:w-1/2 ">
      <div class="">
        <div class="grid grid-rows-2 grid-cols-2 gap-2">
          <div class="row-start-1   col-span-1">
            <div class="mt-2 flex rounded-md shadow-sm">
        <span
          class="inline-flex  items-center rounded-l-md border border-r-0 border-gray-300 px-3 text-gray-900 sm:text-sm">Start</span>
              <input #startTimePicker [(ngModel)]="visibleStartDate" (ngModelChange)="setVisibleDateChanged()" class="px-2 cursor-pointer flex w-full min-w-0 flex-1 rounded-none rounded-r-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                     id="start" name="start"
                     type="date">
            </div>
          </div>
          <div class="row-start-1  col-span-1">
            <div class="mt-2 flex rounded-md shadow-sm">
        <span
          class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 px-3 text-gray-900 sm:text-sm">Ende</span>
              <input #endTimePicker [(ngModel)]="visibleEndDate" (ngModelChange)="setVisibleDateChanged()" class="px-2 cursor-pointer flex w-full min-w-0 flex-1 rounded-none rounded-r-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6" id="end" name="end"
                     type="date">
            </div>
          </div>


          <!--
            Bug #234: `h-full` (Tailwind `height:100%`) replaces `h-100` (Bootstrap `height:100%!important`).
            Behaviourally identical here: nothing else declares a height on this element, so the `!important`
            never mattered. The percentage resolves against this element's GRID AREA (`grid-rows-2` gives two
            equal `1fr` tracks), which is the same size a grid item's default `align-self: stretch` would give
            it — so the class is redundant either way and is kept only to avoid a gratuitous layout change.
          -->
          <div class="h-full row-start-2  mt-4 py-0.5 z-10">
            <ng-select (ngModelChange)="setTimerange($event)" [items]="timePeriods" [ngModel]="selectedTimePeriodId" bindLabel="name"
                       bindValue="id"
                       class="cursor-pointer">
            </ng-select>
          </div>

          <div class="flex w-full justify-end mt-4 col-span-1 ">
            <!-- Disabled until the company zone has answered and the default range is filled in. -->
            <button #runBtn (click)="navigateToAnalyses()" [disabled]="!ready"
                    class="mouse-tracking inline-flex place-self-end rounded-full  bg-theme-primary-700 px-4 py-2.5 text-sm font-semibold text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700 disabled:opacity-30 disabled:grayscale disabled:cursor-not-allowed"
                    type="button">
              <svg class="w-3 h-3 place-self-center fill-none" stroke="currentColor" stroke-width="1.5"
                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>


              <span class="self-center pl-2 block">Analysieren</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!--
    Bug #234: an empty spacer div carrying the Bootstrap `h-25` utility used to sit here. It was Bootstrap
    (`height:25%!important`) and could never resolve: the containing block is this view's root `<div>`, whose
    own `h-full` also resolves to `auto` because the component host declares no height. 25% of `auto` is
    `auto`, and an empty div at `height: auto` is 0px — so the element rendered nothing and is removed rather
    than translated to an equally dead `h-1/4`. If vertical breathing room is ever wanted below the card, add
    real spacing (`pb-*`) to the container instead of a percentage-height spacer.
  -->
</div>

